<c-container fluid>

  <!-- Members List -->
  <c-row>
    <c-col xs="12">
      <c-card class="mb-4">
        <c-card-header>
          <strong>XShop Admin</strong>
          <small class="ms-2 text-body-secondary">{{ members().length }} {{ 'xshop_admin.members' | translate }}</small>
        </c-card-header>
        <c-card-body>
          @if (loadingMembers()) {
            <div class="text-center py-3 text-body-secondary">{{ 'xshop_admin.loading' | translate }}</div>
          } @else if (members().length === 0) {
            <div class="text-center py-3 text-body-secondary">{{ 'xshop_admin.no_members' | translate }}</div>
          } @else {
            <div class="table-responsive">
              <table cTable hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{{ 'xshop_admin.email' | translate }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (member of members(); track member.id) {
                    <tr>
                      <td>{{ member.id }}</td>
                      <td>{{ member.email }}</td>
                      <td class="text-end">
                        <button
                          cButton
                          color="danger"
                          variant="ghost"
                          size="sm"
                          (click)="removeMember(member.id)"
                          [disabled]="removingUserId() === member.id"
                        >
                          {{ 'xshop_admin.remove' | translate }}
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

  <!-- Add Member Search -->
  <c-row>
    <c-col xs="12">
      <c-card class="mb-4">
        <c-card-header>
          <strong>{{ 'xshop_admin.add_member' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="mb-3">
            <label class="form-label">{{ 'xshop_admin.search_placeholder' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [value]="searchQuery()"
              (input)="onSearchInput($any($event.target).value)"
              [placeholder]="'xshop_admin.search_placeholder' | translate"
            />
          </div>

          @if (loadingSearch()) {
            <div class="text-center py-2 text-body-secondary">{{ 'xshop_admin.searching' | translate }}</div>
          }

          @if (searchResults().length > 0) {
            <div class="table-responsive">
              <table cTable hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>{{ 'xshop_admin.email' | translate }}</th>
                    <th>XShop</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (user of searchResults(); track user.id) {
                    <tr>
                      <td>{{ user.id }}</td>
                      <td>{{ user.email }}</td>
                      <td>
                        @if (isMember(user.id)) {
                          <span class="badge bg-success">{{ 'xshop_admin.active' | translate }}</span>
                        } @else {
                          <span class="badge bg-secondary">-</span>
                        }
                      </td>
                      <td class="text-end">
                        @if (!isMember(user.id)) {
                          <button
                            cButton
                            color="primary"
                            size="sm"
                            (click)="addMember(user.id)"
                            [disabled]="addingUserId() === user.id"
                          >
                            {{ 'xshop_admin.add' | translate }}
                          </button>
                        } @else {
                          <button
                            cButton
                            color="danger"
                            variant="ghost"
                            size="sm"
                            (click)="removeMember(user.id)"
                            [disabled]="removingUserId() === user.id"
                          >
                            {{ 'xshop_admin.remove' | translate }}
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else if (searchQuery().length >= 2 && !loadingSearch()) {
            <div class="text-center py-2 text-body-secondary">{{ 'xshop_admin.no_results' | translate }}</div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>

</c-container>
